import { CheckboxPanel_Label_default } from "./chunk-CJ6VROEL.js";
import { CheckboxPanel_default } from "./chunk-N3JZSGUW.js";

// src/components/CheckboxPanel/index.ts
var CheckboxPanelComponent = CheckboxPanel_default;
CheckboxPanelComponent.Label = CheckboxPanel_Label_default;
CheckboxPanelComponent.Label.displayName = "CheckboxPanel.Label";
export { CheckboxPanelComponent };